import { Modal } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useRemovePaymentMethodMutation } from 'api/subscriptionPlanEndpoints';

type Props = {
    onModalClose: () => void;
    onRemoved?: () => void;
    confirmationModalOpen: boolean;
    paymentMethodToken: string;

}

const RemovePaymentMethodModal = ({
    onModalClose,
    onRemoved,
    confirmationModalOpen,
    paymentMethodToken,
}: Props) => {
    const intl = useIntl();
    const [removePaymentMethod, { isLoading }] = useRemovePaymentMethodMutation();

    const onRemove = async () => {
        try {
            await removePaymentMethod(paymentMethodToken).unwrap();
            onRemoved?.();
            onModalClose();
        } catch (e) {
            // handled
        }
    };

    return (
        <Modal
            preventCloseOnClickOutside
            open={confirmationModalOpen}
            onRequestClose={onModalClose}
            onRequestSubmit={onRemove}
            loadingStatus={isLoading ? 'active' : undefined}
            primaryButtonDisabled={isLoading}
            danger
            modalHeading={intl.formatMessage(messages.areYouSure)}
            modalLabel={intl.formatMessage(messages.removePaymentMethod)}
            primaryButtonText={intl.formatMessage(sharedMessages.remove)}
            closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
            secondaryButtonText={intl.formatMessage(sharedMessages.back)}
        />
    );
};

const messages = defineMessages({
    removePaymentMethod: {
        id: 'src.Screens.Dashboard.Subscription.PaymentMethods.RemovePaymentMethodModal.RemovePaymentMethodModal.removingFromOrg',
        defaultMessage: 'Usuń metodę płatności',
    },
    areYouSure: {
        id: 'src.Screens.Dashboard.Subscription.PaymentMethods.RemovePaymentMethodModal.RemovePaymentMethodModal.areYouSure',
        defaultMessage: 'Jesteś pewien, że chcesz usunąć metodę płatności? Ta operacja jest nieodwracalna.',
    },
});

export default RemovePaymentMethodModal;
